import { selectJobRelationshipId } from 'features/scheduleBuilder/slices/jobs/slice';
import { selectUserFullName } from 'features/scheduleBuilder/slices/users/slice';

export function sortByNameCompareFromJob({ state, selectJobId }) {
  return function (a, b) {
    // selectJobId is either selectTimeOffRelationshipId or selectScheduleAvailabilityRelationshipId
    // get the job id from the either entities
    const jobIdA = selectJobId({
      state,
      id: a.id,
      relationship: 'job',
    });
    const jobIdB = selectJobId({
      state,
      id: b.id,
      relationship: 'job',
    });

    // get user id from job
    const userIdA = selectJobRelationshipId({
      state,
      relationship: 'user',
      id: jobIdA,
    });
    const userIdB = selectJobRelationshipId({
      state,
      relationship: 'user',
      id: jobIdB,
    });

    const nameA = (selectUserFullName(state, userIdA) || '').toLowerCase();
    const nameB = (selectUserFullName(state, userIdB) || '').toLowerCase();

    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;

    return parseInt(a.id, 10) < parseInt(b.id, 10) ? -1 : 1;
  };
}
